<template>
    <div class="loader" role="dialog" aria-modal="true" aria-labelledby="loader-title">
        <div class="loader-container">
            <div class="spinner-wrapper">
                <q-spinner-dots class="spinner" color="black" size="3em" />
                <div class="pulse-ring"></div>
            </div>
            <h3 id="loader-title" class="loader-title">
                {{ message }}
            </h3>
            <p class="loader-subtitle">
                {{ subtitle }}
            </p>
            <div class="progress-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </div>
    </div>
</template>
<script>
import { computed } from 'vue'

export default {
    name: 'BetweenPageLoader',
    props: {
        type: {
            type: String,
            default: 'save',
            validator: (value) => ['save', 'load', 'process', 'upload'].includes(value)
        },
        customMessage: {
            type: String,
            default: ''
        },
        customSubtitle: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const messages = {
            save: {
                title: 'Sauvegarde...',
                subtitle: 'Enregistrement de vos modifications en cours'
            },
            load: {
                title: 'Chargement en cours...',
                subtitle: 'Préparation de votre contenu'
            },
            process: {
                title: 'Traitement des données...',
                subtitle: 'Validation de vos informations'
            },
            upload: {
                title: 'Téléchargement en cours...',
                subtitle: 'Envoi de vos fichiers'
            }
        }

        const message = computed(() => {
            return props.customMessage || messages[props.type]?.title || messages.save.title
        })

        const subtitle = computed(() => {
            return props.customSubtitle || messages[props.type]?.subtitle || messages.save.subtitle
        })

        return {
            message,
            subtitle
        }
    }
}
</script>
<style scoped>
.loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(248, 249, 250, 0.95));
    backdrop-filter: blur(8px);
    z-index: 110000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease-out;
}

.loader-container {
    background: white;
    padding: 3rem 2rem;
    border-radius: 20px;
    box-shadow:
        0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);
    text-align: center;
    max-width: 90vw;
    min-width: 320px;
    animation: slideUp 0.4s ease-out 0.1s both;
}

.spinner-wrapper {
    position: relative;
    display: inline-block;
    margin-bottom: 2rem;
}

.spinner {
    position: relative;
    z-index: 2;
}

.pulse-ring {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    border: 3px solid #000000;
    border-radius: 50%;
    opacity: 0.3;
    transform: translate(-50%, -50%) scale(0.8);
    animation: pulse 2s infinite;
}

.loader-title {
    margin: 0 0 0.5rem 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #000000;
    line-height: 1.3;
}

.loader-subtitle {
    margin: 0 0 2rem 0;
    font-size: 1rem;
    color: #6b7280;
    line-height: 1.4;
}

.progress-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #000000;
    opacity: 0.3;
    animation: dotPulse 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.3s;
}

.dot:nth-child(3) {
    animation-delay: 0.6s;
}

/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pulse {
    0%, 100% {
        transform: translate(-50%, -50%) scale(0.8);
        opacity: 0.3;
    }
    50% {
        transform: translate(-50%, -50%) scale(1.2);
        opacity: 0.1;
    }
}

@keyframes dotPulse {
    0%, 100% {
        opacity: 0.3;
        transform: scale(1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .loader-container {
        margin: 1rem;
        padding: 2rem 1.5rem;
    }

    .loader-title {
        font-size: 1.25rem;
    }

    .loader-subtitle {
        font-size: 0.9rem;
    }
}

@media (max-width: 480px) {
    .loader-container {
        padding: 1.5rem 1rem;
        min-width: 280px;
    }

    .pulse-ring {
        width: 60px;
        height: 60px;
    }
}
</style>